<ui-section
	[collapsable]="true"
	[collapsed]="shouldCollapseSignal()"
	[title]="sectionTitle"
	(onCollapsedChange)="onCollapsedChange($event)"
	[testHook]="testHooks.TitleSection"
>
	<div
		section-content
		class="grid grid-cols-2 gap-12"
		*ngIf="settings$ | async as LTTSetting"
	>
		<div class="flex flex-col gap-6 h-fit">
			<h4 class="text-lg font-medium text-gray-950 m-0">Fee Placement</h4>

			<app-direction-of-fee-dropdown
				[currentDirectionOfFee]="LTTSetting.displayIn"
				label="Display Line Item(s) In (LTT & MLTT)"
				fieldToUpdate="LTT.displayIn"
				(directionOfFeeChange)="setDisplayIn($event)"
			/>

			<app-select
				*ngIf="LTTSetting.displayIn !== directionOfFeeType.NONE"
				[required]="true"
				label="Show MLTT admin fee in"
				[ngModel]="LTTSetting.showAdminFeeIn"
				(ngModelChange)="setShowAdminFeeIn($event)"
				[testHook]="testHooks.ShowMlttAdminFeeInSelect"
			>
				@for (option of showFeeOptions; track option.value) {
					<option [value]="option.value" [testHook]="testHooks.Option">
						{{ option.label }}
					</option>
				}
			</app-select>
		</div>

		<div
			class="flex flex-col gap-6 h-fit"
			*ngIf="LTTSetting.displayIn !== directionOfFeeType.NONE"
		>
			<h4 class="text-lg font-medium text-gray-950 m-0">Additional Settings</h4>

			<ui-checkbox
				label="Import LTT and MLTT as separate entries"
				[ngModel]="LTTSetting.separateEntities"
				(ngModelChange)="setSeparateEntities($event)"
				[testHook]="testHooks.ImportLttAndMlttAsSeparateEntriesCheckbox"
			/>
		</div>
	</div>
</ui-section>
